import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { notification } from "top-component-library";
import { generalErrorAlert } from "util/Utils";

import { MenuData, MenuPayload } from "./menuUtils";
import { SelectedCustomer } from "./types";

export const useMenus = (selectedCustomer: SelectedCustomer) => {
  const customerId = selectedCustomer?.customer_id;

  const [menus, setMenus] = useState<MenuData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(async () => {
    if (!customerId) return;
    setIsLoading(true);
    try {
      const res = await axios.post<{ menus: MenuData[] }>("/api/allmenus/getMenus/", { customer_id: customerId });
      setMenus(res.data.menus ?? []);
    } catch (error) {
      generalErrorAlert(error, "There was an error loading your menus, please refresh.");
    } finally {
      setIsLoading(false);
    }
  }, [customerId]);

  useEffect(() => {
    load();
  }, [load]);

  const saveMenu = useCallback(
    async (payload: MenuPayload) => {
      try {
        await axios.post("/api/allmenus/updateMenuProperties/", payload);
        if (payload.combine_into_id) {
          notification.info({
            message:
              "Menu settings updated. This menu is displayed as part of another menu, so it follows that menu's allowed delivery/pickup times.",
            duration: 12,
          });
        } else {
          notification.success({ message: "Menu settings updated." });
        }
        await load();
      } catch (error) {
        generalErrorAlert(error, "There was an error updating your Menu settings. Please check your inputs.");
      }
    },
    [load]
  );

  return { menus, isLoading, saveMenu, refresh: load };
};
